/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForSbomParser extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForSbomParser");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForSbomParser.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForSbomParser>): BackgroundJobPayloadForSbomParser {
        let obj = Object.assign(new BackgroundJobPayloadForSbomParser(), model);
        BackgroundJobPayloadForSbomParser.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForSbomParser>): BackgroundJobPayloadForSbomParser {
        if (!model) return null;
        return BackgroundJobPayloadForSbomParser.newInstance(<BackgroundJobPayloadForSbomParser> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForSbomParser) {
        if (!obj) return;

        models.BackgroundJobPayloadForSbomParser.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForSbomParser): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForSbomParser.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Unique ID of the SBOM version to be parsed
     */
    sbom_version_id: string;

    /**
     * Flag to indicate if this is a re-parsing operation
     */
    reparse: boolean = false;

    /**
     * Data store to be parsed for the given SBOM version, reparse flag has to be set to true to reparse for the given data store. If no data store is provided, parsing will be done for all data stores.
     */
    data_store: models.SbomParsingDataStore;

}
